import InteractiveMapContainerMobile from './InteractiveMapContainerMobile';

export default InteractiveMapContainerMobile;
